module.exports = __webpack_public_path__ + "static/media/light-theme-selected-mode-icon.743ae804.svg";